<template>
  <div>
    <el-row :gutter="20" ref="rowBox">
      
      <el-col v-for="item in col" :span="span"  ></el-col>
    </el-row>
  </div>
</template>

<script>
  export default{
    name: 'RowBox',
    props: ['col'],
    computed:{
      span(){
        this.$nextTick(() => {
          
        })
      }
    },
    created(){
      this.$nextTick(() => {
        
      })
    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/rowBox.vue